import './GeneralSettings.scss'
import {Button} from "../../Form/Button/Button";
import {buttonColors} from "../../Pickers/InputTheme";
import VrpanoOutlinedIcon from "@mui/icons-material/VrpanoOutlined";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import StickyNote2OutlinedIcon from "@mui/icons-material/StickyNote2Outlined";
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import React, {useContext, useState} from "react";
import {UploadOrgLogoModal} from "../UploadLogoModal/UploadOrgLogoModal";
import {EditNotesModal} from "../EditNotesModal/EditNotesModal";
import {EditOrgNameModal} from "../EditOrgNameModal/EditOrgNameModal";
import {UserReactContext} from "../../../contexts/UserContext";
import {I18nReactContext} from "../../../contexts/I18nContext";


export const GeneralSettings = () => {
    const [editLogoModalOpen, setEditLogoModalOpen] = useState(false)
    const [editNotesModalOpen, setEditNotesModalOpen] = useState(false)
    const userContext = useContext(UserReactContext)
    const {i18n} = useContext(I18nReactContext);

    const closeEditLogoModal = () => {
        setEditLogoModalOpen(false)
    }
    const openEditLogoModal = () => {
        setEditLogoModalOpen(true)
    }
    const openEditNotesModal = () => {
        setEditNotesModalOpen(true)
    }
    const closeEditNotesModal = () => {
        setEditNotesModalOpen(false)
    }
    return <div className="GeneralSettings">
        <div className="ButtonsRow">
            {userContext.isManagingCompany() ? <Button color={buttonColors.GREY}

                                                       text={i18n.translate('settingsPage.buttons.updateLogo')}
                                                       icon={<VrpanoOutlinedIcon/>}
                                                       onClick={openEditLogoModal}/> : ''}

            <Button color={buttonColors.GREY}
                    text={i18n.translate('settingsPage.buttons.updateNotes')}
                    icon={<StickyNote2OutlinedIcon/>}
                    onClick={openEditNotesModal}/>
                <Button color={buttonColors.GREY}
                        text={i18n.translate('settingsPage.buttons.adminInstructionCourse')}
                        icon={<SchoolOutlinedIcon/>}
                        onClick={() => window.open(process.env.REACT_APP_ADMIN_COURSEWARE_URL, '_blank')}/>
        </div>
        <UploadOrgLogoModal
            editLogoModalOpen={editLogoModalOpen}
            closeEditLogoModal={closeEditLogoModal}
        />

        {editNotesModalOpen && <EditNotesModal
            editNotesModalOpen={editNotesModalOpen}
            closeEditNotesModal={closeEditNotesModal}/>}
    </div>
}